import React__default from "react";
import clsx from "clsx";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { CarouselNavButton } from "./carousel-nav-button.mjs";
import { CarouselPlayPauseButton } from "./carousel-play-pause-button.mjs";
const CarouselNav = ({
  prevArrowText,
  nextArrowText,
  arrowStyle,
  isScrollStart,
  isScrollEnd,
  onPrevArrowClick,
  onNextArrowClick,
  onPausePlayClick,
  pausePlayIconType,
  hasPausePlayButton,
  hasArrows,
  centerArrows
}) => {
  const labels = useLabels();
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: clsx("carousel__slider-nav", {
        ["carousel__slider-nav--small"]: (arrowStyle == null ? void 0 : arrowStyle.size) === "small",
        ["carousel__slider-nav--link"]: (arrowStyle == null ? void 0 : arrowStyle.link) === true,
        ["carousel__slider-nav--center"]: centerArrows === true
      })
    },
    hasPausePlayButton && /* @__PURE__ */ React__default.createElement(
      CarouselPlayPauseButton,
      {
        text: pausePlayIconType === "pause" ? labels.get("pause") : labels.get("play"),
        ...arrowStyle,
        onClick: onPausePlayClick,
        iconType: pausePlayIconType,
        disabled: isScrollEnd && pausePlayIconType === "play"
      }
    ),
    hasArrows && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      CarouselNavButton,
      {
        text: prevArrowText != null ? prevArrowText : labels.get("carousel.previous"),
        ...arrowStyle,
        onClick: onPrevArrowClick,
        arrowType: "prev",
        disabled: isScrollStart
      }
    ), /* @__PURE__ */ React__default.createElement(
      CarouselNavButton,
      {
        text: nextArrowText != null ? nextArrowText : labels.get("carousel.next"),
        ...arrowStyle,
        onClick: onNextArrowClick,
        arrowType: "next",
        disabled: isScrollEnd
      }
    ))
  );
};
export {
  CarouselNav
};
